var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWalletconnect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    className: "w-10 h-10 ",
    color: "text",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.681 12.476c6.251-6.079 16.387-6.079 22.638 0l.752.731a.763.763 0 010 1.1l-2.573 2.503a.408.408 0 01-.566 0l-1.035-1.006c-4.362-4.241-11.432-4.241-15.793 0l-1.11 1.078a.408.408 0 01-.565 0l-2.574-2.503a.763.763 0 010-1.1l.826-.803zm27.96 5.175l2.291 2.227a.763.763 0 010 1.101L28.604 31.022a.817.817 0 01-1.132 0l-7.33-7.128a.204.204 0 00-.283 0l-7.33 7.128a.817.817 0 01-1.133 0L1.068 20.979a.763.763 0 010-1.1l2.29-2.228a.817.817 0 011.132 0l7.33 7.128a.204.204 0 00.284 0l7.33-7.128a.817.817 0 011.132 0l7.33 7.128a.204.204 0 00.283 0l7.33-7.128a.816.816 0 011.133 0z",
    fill: "#3389FB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletconnect);
export default __webpack_public_path__ + "static/media/walletconnect.8a70da84.svg";
export { ForwardRef as ReactComponent };